import { render, staticRenderFns } from "./ProfessorEvaluationsJoined.vue?vue&type=template&id=113bf8a4&scoped=true"
import script from "./ProfessorEvaluationsJoined.vue?vue&type=script&lang=js"
export * from "./ProfessorEvaluationsJoined.vue?vue&type=script&lang=js"
import style0 from "./ProfessorEvaluationsJoined.vue?vue&type=style&index=0&id=113bf8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113bf8a4",
  null
  
)

export default component.exports